import { Toast } from 'components/Modal';
import { apiClient } from 'modules';
import useTitle from 'modules/useTitle';
import React, { useEffect, useState } from 'react';
import styles from './index.module.scss';

export default function InvitationList() {
  useTitle('邀请赚红包');
  const [toastVisible, setToastVisible] = useState(false);
  const [message, setMessage] = useState('');
  const [poster, setPoster] = useState('');

  function showToast(newMessage: string) {
    setMessage(newMessage);
    setToastVisible(true);

    setTimeout(() => {
      setToastVisible(false);
    }, 2000);
  }

  async function fetchPoster() {
    const response = await apiClient.invite.poster();

    if (response.status !== 10000) {
      showToast(response.msg);
      return;
    }

    setPoster(response.body.url);
  }

  useEffect(() => {
    fetchPoster();
  }, []);

  return (
    <div className={styles.container}>
      <Toast isOpen={toastVisible} message={message} />
      <div className={styles.hint}>长按下面图片保存</div>
      <img src={poster} className={styles.image} />
      <div className={styles.tip}>长按上面图片保存</div>
      <div className={styles.tip}>&lt; 保存后，发到微信群或者朋友圈 &gt;</div>
    </div>
  );
}
